import { defineComponent as _defineComponent } from 'vue'
import InvoiceSection from '@/views/my-projects/components/invoice/InvoiceSection.vue';
import IconLightBulb from '@/components/svg/profile-lightbulb.svg?inline';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import InvoiceAttachmentFileTable from '@/views/my-projects/components/invoice/attachments/InvoiceAttachmentFileTable.vue';
import UploadableItem from '@/components/molecules/UploadableItem.vue';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import { computed, ref, watchEffect } from 'vue';
import { cloneDeep } from 'lodash';
import useUser from '@/mixins/useUser';
import { until, whenever } from '@vueuse/core';
import { PayloadAttachment } from '@/models/Invoice';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceAttachments',
  setup(__props) {

const {
  componentAttachmentsData, canInvoiceBeEdited, fetchAddAttachment, isAttachmentRequestRunning
} = useInvoice();
const { tUserFallback: t } = useUser('self');
const localAttachmentsData = ref(cloneDeep(componentAttachmentsData.value));

const totalSizeOfAllAttachments = computed(() => localAttachmentsData.value.reduce((acc, attachment) => (acc + attachment.size), 0));
const fileContents = ref('');
const fileName = ref('');
const fileType = ref('');
const mimeTypes = [
  // Textformate
  'text/plain', // txt
  'application/pdf', // pdf
  'application/msword', // doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
  'application/vnd.oasis.opendocument.text', // odt
  'application/rtf', // rtf
  'application/vnd.ms-excel', // xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
  'application/vnd.ms-powerpoint', // ppt
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // pptx
  'application/vnd.openxmlformats-officedocument', // Generic term for modern Microsoft Office files

  // Bildformate
  'image/jpeg', // jpeg, jpg
  'image/png', // png
  'image/tiff', // tif
  'image/bmp', // bmp
  'image/webp', // webp

  // Container
  'application/zip',
  'application/x-zip-compressed', // zip

  // For files within the zip container
  'application/java-archive', // .jar
  'application/vnd.openxmlformats-officedocument',
  'application/vnd.oasis.opendocument.text' // .odt
];

function createAttachmentPayload(): PayloadAttachment {
  return {
    description: '',
    file: {
      attachment: fileContents.value,
      fileType: fileType.value,
      filename: fileName.value,
    }
  };
}

whenever(() => fileContents.value.length > 0, async () => {
  // Make sure the fileName has updated as well before proceeding
  await until(fileName).not.toBe('');

  try {
    await fetchAddAttachment(0, createAttachmentPayload()).then((data) => {
      localAttachmentsData.value = data.attachments;
      componentAttachmentsData.value = localAttachmentsData.value;
    });
  } finally {
    fileContents.value = '';
    fileName.value = '';
    fileType.value = '';
  }
});

// If reactive data changes, it is updated
watchEffect(() => {
  localAttachmentsData.value = cloneDeep(componentAttachmentsData.value);
});


return { __sfc: true,componentAttachmentsData, canInvoiceBeEdited, fetchAddAttachment, isAttachmentRequestRunning, t, localAttachmentsData, totalSizeOfAllAttachments, fileContents, fileName, fileType, mimeTypes, createAttachmentPayload, InvoiceSection, IconLightBulb, BCXMarkdown, InvoiceAttachmentFileTable, UploadableItem }
}

})